module.exports = __webpack_public_path__ + "img/author_thumbnail.0e7121a5.jpg";